import { createContext } from "react";

// Use for disable focus on regular options inside react-select
export const StickyOptionsFocusContext = createContext<boolean>(false);
